<template>
  <div class="navigation">

    <nav class="flex items-center justify-between flex-wrap bg-blue-500 p-6">

      <div class="flex items-center flex-shrink-0 text-white mr-6">

        <router-link tag="div" to="/" class="cursor-pointer">
          <img :src="require('@/assets/logo_weissenburgbad.png')" alt="" width="100px" class="mr-6">
        </router-link>

        <router-link tag="div" to="/" class="hidden md:block  text-2xl cursor-pointer"> Verein Bad und Thermalquelle Weissenburg</router-link>

      </div>

      <div class="block mx-auto mt-4 md:hidden">
        <button @click="showmenu = !showmenu" class="flex items-center px-3 py-2 border rounded text-white text-2xl">
          <i class="fas fa-bars"> </i>
        </button>
      </div>

      <!-- DESKTOP MENU -->
      <div class="hidden w-full md:block flex-grow md:flex md:items-center md:w-auto" >

        <div class="text-xl text-right md:flex-grow">
          <!-- <a href="" class="block mt-4 md:inline-block md:mt-0 text-white hover:text-white mr-4">
          Übersicht
        </a> -->

        <router-link :to="'/'" class=" text-white hover:text-white mr-4" :class="{currentnav: this.$router.currentRoute.name == 'verein' || this.$router.currentRoute.name == 'detailverein'}">

          <i class="far fa-user"></i> Verein

        </router-link>

        <router-link :to="'../geschichte'" class=" text-white hover:text-white mr-4" :class="{currentnav: this.$router.currentRoute.name == 'geschichte'}">

        <i class="fas fa-landmark"></i> Geschichte

      </router-link>

      <router-link :to="'/wandern'" class="block mt-4 md:inline-block md:mt-0 text-white hover:text-white mr-4" :class="{currentnav: this.$router.currentRoute.name == 'home'}">

        <i class="fas fa-hiking"></i> Wandern

      </router-link>

    </div>

  </div>

</nav>


<!-- Mobile Menu -->
<div v-if="showmenu" class="bg-blue-500 z-40 fixed w-full h-full top-0 left-0 opacity-95">

  <div @click="showmenu = !showmenu" class="text-white text-center text-4xl mb-4 mt-4">
    <i class="fas fa-times z-50 cursor-pointer"></i>
  </div>

  <router-link tag="div" :to="'/'" class="text-white text-center text-4xl mb-4 cursor-pointer">
    <p @click="showmenu = !showmenu" class="text-center"> <span class="text-white  text-4xl mb-4">Verein</span> </p>
  </router-link>

  <router-link   tag="div" :to="'/'" class="text-white text-center text-4xl mb-4 cursor-pointer">
    <p class="text-center" @click="showmenu = !showmenu"> <span class="text-white text-center text-xl mb-4" :class="{currentnav: this.$router.currentRoute.name == 'verein'}">Über den Verein</span> </p>
  </router-link>

  <router-link tag="div" :to="'../verein/news'" class="text-white text-center text-4xl mb-4 cursor-pointer">
    <p class="text-center" @click="showmenu = !showmenu"> <span class="text-white text-center text-xl mb-4" :class="{currentnav: this.$route.params.url == 'news'}">News & Veranstaltungen</span> </p>
  </router-link>

  <router-link tag="div" :to="'../verein/galerie'" class="text-white text-center text-4xl mb-4 cursor-pointer">
    <p class="text-center" @click="showmenu = !showmenu"> <span class="text-white text-center text-xl mb-4" :class="{currentnav: this.$route.params.url == 'galerie'}">Bildergalerien</span> </p>
  </router-link>

  <router-link tag="div" :to="'../verein/kontakt'" class="text-white text-center text-4xl mb-4 cursor-pointer">
    <p class="text-center" @click="showmenu = !showmenu"> <span class="text-white text-center text-xl mb-4" :class="{currentnav: this.$route.params.url == 'kontakt'}">Kontakt</span> </p>
  </router-link>

  <router-link tag="div" :to="'../verein/mitglied'" class="text-white text-center text-4xl mb-4 cursor-pointer">
    <p class="text-center" @click="showmenu = !showmenu"> <span class="text-white text-center text-xl mb-4" :class="{currentnav: this.$route.params.url == 'mitglied'}">Mitglied werden</span> </p>
  </router-link>

  <router-link tag="div" :to="'/geschichte'" replace class="text-white text-center text-4xl mb-4 cursor-pointer">
  <p class="text-center" @click="showmenu = !showmenu"> <span class="text-white text-center text-4xl mb-4" :class="{currentnav: this.$router.currentRoute.name == 'geschichte'}">Geschichte</span> </p>
</router-link>

<router-link tag="div" :to="'/wandern'" class="text-white text-center text-4xl mb-4 cursor-pointer">
  <p class="text-center" @click="showmenu = !showmenu"> <span class="text-white text-center text-4xl mb-4" :class="{currentnav: this.$router.currentRoute.name == 'home'}">Wandern</span> </p>
</router-link>

</div>




</div>

</template>

<script>
export default {
  name: 'Navigation',
  props: {

  },
  data() {
    return {
      hausarzt: [],
      kinderarzt: [],
      physio:[],
      psychotherapie:[],
      magendarm: [],
      ernährung: [],
      labor: [],
      showmenu: false,
    }
  },
  methods: {

    getroute(){
      // console.log(this.$router.currentRoute.name);
    },

  },
  mounted: function(){
    this.getroute();
  },

  computed: {

  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.dropdown-content {
  display: none;
  right: 0;
  position: absolute;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.currentnav {

  border-bottom: 3px solid white;

}

</style>
